import { CircularProgress } from '@mui/material'
import { LoadingWrapper } from './LoadingIndicator.styled'

const LoadingIndicator = () => {
  return (
    <LoadingWrapper>
      <CircularProgress />
    </LoadingWrapper>
  )
}

export default LoadingIndicator
